module.exports = __webpack_public_path__ + "static/media/4.7bc209e9.jpg";